<template>
  <template v-if="hasFeature">
    <slot />
  </template>
  <template v-else>
    <slot name="fallback" />
  </template>
</template>

<script setup lang="ts">
import { computed } from "vue";

import features from "shared/services/features";
import type { FeatureKey } from "shared/types/features";

interface HasFeatureProps {
  feature: FeatureKey;
}

const props = defineProps<HasFeatureProps>();

const hasFeature = computed<boolean>(() => features.has(props.feature));
</script>
